// extracted by mini-css-extract-plugin
export default {"eventContainer":"EventContainer_eventContainer__Avg4-","eventItem":"EventContainer_eventItem__sCBx5"};